import { ridSegment } from '@krp/client-runtime'

/**
 * Адрес расширения карточки 1С (ADR-21, RP-FB71): служба отдаёт его из своего зеркала, без обращения к 1С. Литерал `/api/`
 * законен только в файлах `api/urls.ts` (eslint). rid и ключ экранируются: ключ из адреса окна — ввод человека.
 */
export const ONEC_PRODUCT_EXTENSION_URLS = {
  extension: (resourceId: string, refKey: string) =>
    `/api/onec/v1/resources/${ridSegment(resourceId)}/catalog/products/${encodeURIComponent(refKey)}/extension`,
} as const
